import { t } from 'i18next'
import { z } from 'zod'

import { hasHttpProtocol } from 'features/yieldbirdWrapperAgent/utils/url'

const SAFE_MAX_URL_LENGTH: number = 2_048

const DEFAULT_PROTOCOL: string = 'https://'

const isValidUrl = (value: string): boolean =>
  z.httpUrl().safeParse(hasHttpProtocol(value) ? value : `${DEFAULT_PROTOCOL}${value}`).success

export const schema = z.object({
  url: z
    .string()
    .trim()
    .min(1)
    .max(SAFE_MAX_URL_LENGTH)
    .refine(isValidUrl, {
      error: () => t('features/yieldbirdWrapperAgent:form.url.error.invalid'),
    }),
})

export type Schema = z.infer<typeof schema>

export const schemaDefaults: Schema = {
  url: '',
}
